/**
 * Getting Started Article Content
 */

export const gettingStartedContent = `---
id: getting-started-guide
title: Getting started
description: Create an account and organization, then create your first tournament.
category: getting-started
type: tutorial
estimatedTime: 5 min read
path: /support/tutorials/getting-started
lastUpdated: 2026-08-20
version: 3.0
tags:
  - getting-started
  - onboarding
  - account-setup
  - first-tournament
seo:
  title: Getting started - Bowling Tournament App
  description: Create an account and organization, then create your first tournament.
  keywords:
    - bowling tournament app
    - getting started
    - tournament setup
    - organization
---

# Getting started

Click **Create Tournament**. Log in if you have an account. Create an account if you do not. New accounts create an organization in that same flow. After you save, the app opens **Setup**.

Your email address is your login. It cannot be changed later. Use **Forgot password** on the login page if you need a new password. If you do not get the verification email, check spam.

An organization is who runs the tournaments. A bowling center is the house. Those can be the same business, and they can use the same name. One organization can also use more than one bowling center.

Handicap, payout ratio, events, and squads are in [How to create a bowling tournament](/support/tutorials/create-tournament). Scoring, averages, and payouts are in [How to run a bowling tournament](/support/tutorials/run-a-tournament). Brackets are in [How to run bowling brackets](/support/tutorials/run-brackets).

---

**[Create a tournament](/create-tournament)**

- [How to run bowling brackets](/support/tutorials/run-brackets)
- [Frequently asked questions](/support/faqs)
`;

export default gettingStartedContent;
